import { USMap } from './Map';

export const geolocationIconMapper = {
  USA: USMap,
  CA: null,
};

export default geolocationIconMapper;
